export const WELL_FIELDS_LIST = 'WELL_FIELDS_LIST';
export const WELL_FIELDS_LIST_SUCCESS = 'WELL_FIELDS_LIST_SUCCESS';
export const WELL_FIELDS_LIST_ERROR = 'WELL_FIELDS_LIST_ERROR';

export const WELL_FIELDS_UPDATE_DATA = 'WELL_FIELDS_UPDATE_DATA';

export const WELL_FIELDS_PLOT = 'WELL_FIELDS_PLOT';
export const WELL_FIELDS_PLOT_SUCCESS = 'WELL_FIELDS_PLOT_SUCCESS';
export const WELL_FIELDS_PLOT_ERROR = 'WELL_FIELDS_PLOT_ERROR';